export const FASE_1_SIZE = 9;
export const FASE_2_SIZE = 5; // pantallas reales de la fase 2 (10..14)
// La barra de pasos (StepNav) tiene 4 pestañas: RECETAS · TU PLAN · EXTRAS · CHECKOUT.
// "¿Cómo quieres empezar?" (pantalla 12) NO tiene pestaña propia: comparte TU PLAN.
// El contador de la cabecera debe reflejar esas 4 posiciones, no las 5 pantallas.
export const FASE_2_TABS = 4;
// pantalla(10..14) → posición de pestaña(1..4). Indexado por (pantalla - FASE_1_SIZE) = 1..5.
const FASE_2_POSITION = [0, 1, 2, 2, 3, 4];
const FASE_1_LABEL = 'Perfil';
const FASE_2_LABEL = 'Diseña su menú';

export interface PhaseProgress {
  phase: 1 | 2;
  label: string;
  current: number; // 1-based within the phase
  total: number;
  percent: number;
}

export function getPhaseProgress(pantalla: number): PhaseProgress {
  if (pantalla <= FASE_1_SIZE) {
    const current = Math.max(1, Math.min(FASE_1_SIZE, pantalla));
    return {
      phase: 1,
      label: FASE_1_LABEL,
      current,
      total: FASE_1_SIZE,
      percent: Math.round((current / FASE_1_SIZE) * 100),
    };
  }
  const raw = Math.max(1, Math.min(FASE_2_SIZE, pantalla - FASE_1_SIZE));
  const current = FASE_2_POSITION[raw];
  return {
    phase: 2,
    label: FASE_2_LABEL,
    current,
    total: FASE_2_TABS,
    percent: Math.round((current / FASE_2_TABS) * 100),
  };
}
